import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';

export type LayoutTheme = 'legacy' | 'neon';

@Injectable({ providedIn: 'root' })
export class LayoutThemeService {

    public static readonly STORAGE_KEY = 'neon-layout-theme';

    private activeTheme: LayoutTheme;

    constructor(@Inject(DOCUMENT) private document: Document) {
        this.activeTheme = this.readSavedTheme();
        this.applyThemeClass();
    }

    public get currentTheme(): LayoutTheme {
        return this.activeTheme;
    }

    public get isNeon(): boolean {
        return this.activeTheme === 'neon';
    }

    public get isLegacy(): boolean {
        return this.activeTheme === 'legacy';
    }

    // Alterna entre o layout moderno e o layout classico.
    public toggleTheme(): void {
        this.setTheme(this.isNeon ? 'legacy' : 'neon');
    }

    // Aplica o tema escolhido e guarda a preferencia neste navegador.
    public setTheme(theme: LayoutTheme): void {
        this.activeTheme = theme;
        this.saveTheme(theme);
        this.applyThemeClass();
    }

    private readSavedTheme(): LayoutTheme {
        try {
            const savedTheme = localStorage.getItem(LayoutThemeService.STORAGE_KEY) || this.readThemeCookie();
            return savedTheme === 'legacy' ? 'legacy' : 'neon';
        } catch (error) {
            return this.readThemeCookie() === 'legacy' ? 'legacy' : 'neon';
        }
    }

    private saveTheme(theme: LayoutTheme): void {
        try {
            localStorage.setItem(LayoutThemeService.STORAGE_KEY, theme);
        } catch (error) {
            // O tema continua ativo durante a sessao mesmo sem armazenamento local.
        }

        this.document.cookie = LayoutThemeService.STORAGE_KEY + '=' + theme
            + '; max-age=31536000; path=/; SameSite=Lax';
    }

    private readThemeCookie(): string {
        const cookiePrefix = LayoutThemeService.STORAGE_KEY + '=';
        const cookies = (this.document.cookie || '').split(';');

        for (let index = 0; index < cookies.length; index++) {
            const cookie = cookies[index].trim();
            if (cookie.indexOf(cookiePrefix) === 0) {
                return cookie.substring(cookiePrefix.length);
            }
        }

        return null;
    }

    private applyThemeClass(): void {
        const body = this.document.body;
        body.classList.remove('theme-neon', 'theme-legacy');
        body.classList.add(this.isNeon ? 'theme-neon' : 'theme-legacy');
    }
}
